// extracted by mini-css-extract-plugin
export var button = "_jt-0";
export var donut = "_jt-1";
export var donutFill = "_jt-3";
export var donutTrack = "_jt-2";